import { lazyLoad } from 'app/utils/loadable';

export const LoginPage = lazyLoad(
  () => import('./login-page'),
  (module) => module.LoginPage
);
